import React, { useState, useEffect } from 'react';
import { Copy, Check } from 'lucide-react';

function mySiteStatusPillClass(status) {
  if (status === 'Submitted') return 'mgr-site-status-pill mgr-site-status-pill--submitted';
  if (status === 'Pending Review') return 'mgr-site-status-pill mgr-site-status-pill--pending';
  return 'mgr-site-status-pill mgr-site-status-pill--not-submitted';
}

export default function ManagerSitesModal(props) {
  const {
    open,
    type,
    pendingSites,
    completedSites,
    mySites = [],
    mySitesNotSubmittedCount = 0,
    onClose,
    onSendReminder,
    reminderSending,
    reminderMessage,
    reminderCooldownUntil
  } = props;
  const [copiedSiteId, setCopiedSiteId] = useState(null);

  useEffect(() => {
    if (!open) setCopiedSiteId(null);
  }, [open]);

  if (!open || !type) return null;

  const list = type === 'pending' ? pendingSites : type === 'completed' ? completedSites : mySites;
  const title =
    type === 'pending'
      ? 'Sites with Pending Review'
      : type === 'completed'
        ? 'Sites Completed'
        : 'My Sites';
  const inCooldown = reminderCooldownUntil && new Date() < new Date(reminderCooldownUntil);

  const copyEmail = async (email, siteId) => {
    if (!email) return;
    try {
      await navigator.clipboard.writeText(email);
      setCopiedSiteId(String(siteId));
      window.setTimeout(() => setCopiedSiteId(null), 1500);
    } catch (_) {
      /* ignore */
    }
  };

  const isMySites = type === 'notSubmitted';

  return (
    <div
      style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}
      onClick={onClose}
    >
      <div
        className="card mgr-sites-modal-card"
        style={{ maxWidth: isMySites ? 720 : 600, width: '90%', maxHeight: '80vh', overflow: 'auto' }}
        onClick={e => e.stopPropagation()}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
          <h3 style={{ margin: 0 }}>{title}</h3>
          <div style={{ display: 'flex', gap: 8 }}>
            {isMySites && (
              <button
                type="button"
                className="btn btn-sm btn-primary"
                onClick={onSendReminder}
                disabled={mySitesNotSubmittedCount === 0 || reminderSending || inCooldown}
              >
                {reminderSending ? 'Sending...' : 'Send Reminder'}
              </button>
            )}
            <button type="button" className="btn btn-sm btn-secondary" onClick={onClose}>
              Close
            </button>
          </div>
        </div>
        {isMySites && reminderMessage && (
          <p
            style={{
              marginBottom: 12,
              fontWeight: 'bold',
              color: reminderMessage.startsWith('Reminder successfully') ? '#28a745' : '#dc3545'
            }}
          >
            {reminderMessage}
          </p>
        )}
        {list.length === 0 ? (
          <p style={{ color: 'var(--color-text-muted)' }}>No sites in this list.</p>
        ) : (
          <div className="table-container mgr-sites-modal-table-wrap">
            <table className="table mgr-sites-modal-table">
              <thead>
                <tr>
                  <th>Site Name</th>
                  {isMySites && <th>Site email address</th>}
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {list.map(s => (
                  <tr key={s.siteId}>
                    <td>{s.siteName}</td>
                    {isMySites && (
                      <td className="mgr-sites-modal-email-td">
                        {s.siteEmail ? (
                          <span className="mgr-site-email-cell">
                            <span className="mgr-site-email-text">{s.siteEmail}</span>
                            <button
                              type="button"
                              className="mgr-site-email-copy"
                              title="Copy email"
                              aria-label={`Copy email for ${s.siteName}`}
                              onClick={() => copyEmail(s.siteEmail, s.siteId)}
                            >
                              {copiedSiteId === String(s.siteId) ? <Check size={14} /> : <Copy size={14} />}
                            </button>
                          </span>
                        ) : (
                          <span className="mgr-site-email-missing">—</span>
                        )}
                      </td>
                    )}
                    <td>
                      {isMySites ? (
                        <span className={mySiteStatusPillClass(s.status)}>{s.status}</span>
                      ) : (
                        s.status
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
